var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('StatusView',{attrs:{"status":_vm.status,"cpuHistory":_vm.cpuHistory,"ramHistory":_vm.ramHistory,"incidents":_vm.incidents}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }